module.exports = __webpack_public_path__ + "assets/approved.8c8a2f55.svg";